export default __webpack_public_path__ + "711b421806bfd09a2ae579c496853fd5.svg";